import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { getProfileApi } from "../../services/profile.service";

interface PublicLayoutProps {
  children?: any;
}

const PublicLayout: React.FC<PublicLayoutProps> = (props) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const state: any = useAppSelector((state) => state.profile);
  const location = useLocation();
  const pathName = location.pathname.includes(
    "/product-opinion" || "/product-opinion/"
  );
  const isEditPorfile = location.pathname === "/edit-profile";
  let token = localStorage.getItem("alrounderToken");
  const isAuthenticated = token ? true : false;
  let userData = state?.userData;
  const hasStore = userData?.has_store;
  const surveyStatus = userData?.survey_status;
  const isRevise = userData?.can_revise;
  const isProcessing = location.pathname === "/processing";

  // useEffect(() => {
  //   if (hasStore && surveyStatus === "responded" && isRevise) {
  //     let url = "/skincaresteps";
  //     navigate(url);
  //   } else if (hasStore && surveyStatus === "responded") {
  //     let url = "/store";
  //     navigate(url);
  //   }
  // }, [hasStore, isEditPorfile, isRevise, location, navigate, surveyStatus]);

  useEffect(() => {
    if (!hasStore && !isAuthenticated && isProcessing) {
      let url = "/login";
      navigate(url);
    }
  }, [hasStore, isAuthenticated, isProcessing, location, navigate]);

  if (!isAuthenticated && pathName) {
    let url = "/skincaresteps";
    navigate(url);
  }

  if (isAuthenticated && pathName && surveyStatus === "paid") {
    let url = "/processing";
    navigate(url);
  }

  // useEffect(() => {
  //   fetchProfile()
  // }, [])

  // if hasStore is true and surveyStatus is responded
  // if (hasStore && isRevise) {
  //   let url = '/skincaresteps';
  //   return <Navigate to={url} />;
  // }

  // if (hasStore && surveyStatus === "responded") {
  //   let url = '/store';
  //   return <Navigate to={url} />;
  // }

  // if (!isAuthenticated && pathName) {
  //   let url = '/skincaresteps';
  //   return <Navigate to={url} />;
  // }

  // if (!isAuthenticated && pathName) {
  //   let url = '/login';
  //   if (location?.hash === "#unsubscribe") {
  //     url = '/login#unsubscribe';
  //   }
  //   return <Navigate to={url} replace />;
  // }

  // const fetchProfile = () => {
  //   dispatch(getProfileApi({
  //     finalCallback: () => {

  //     },
  //     successCallback: (data?: any) => {
  //       // setNavigateTo(handleNavigation(data?.survey_status))
  //     },
  // unauthenticatedCallback:()=>{

  // }
  //   }))
  // }

  return <>{props.children}</>;
};

export default PublicLayout;
